/**
 * scheduled-report.api.ts — Reportes programados (Fase D, ítem 5b).
 * Espejo de `aws-serverless/src/models/scheduled-report.model.ts`.
 */

import { apiClient } from './client';
import type { DashboardReportType } from '../types/api.types';

export type ReportFrequency = 'WEEKLY' | 'MONTHLY';

export interface ScheduledReport {
  scheduleId: string;
  tenantId: string;
  type: DashboardReportType;
  loteId?: string;
  frequency: ReportFrequency;
  nextRunAt: string;
  createdBy: string;
  active: boolean;
  createdAt: string;
  lastRunAt?: string;
  /** Corte semanal (2026-09-12) — solo aplica a WEEKLY_FIELD_REPORT. */
  pushToTelegram?: boolean;
}

export interface CreateScheduledReportRequest {
  type: DashboardReportType;
  loteId?: string;
  frequency: ReportFrequency;
  pushToTelegram?: boolean;
}

export const fetchScheduledReports = async (): Promise<ScheduledReport[]> =>
  (await apiClient.get('/api/scheduled-reports')).data.items ?? [];

export const createScheduledReport = async (req: CreateScheduledReportRequest): Promise<ScheduledReport> =>
  (await apiClient.post('/api/scheduled-reports', req)).data.schedule;

export const deleteScheduledReport = async (scheduleId: string): Promise<void> => {
  await apiClient.delete(`/api/scheduled-reports/${scheduleId}`);
};
